import {
  Box,
  Button,
  Center,
  LoadingOverlay,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import type { CustomNextPage } from "next";
import Link from "next/link";
import { useState } from "react";
import { AuthLayout } from "src/layout";
import { errorShowNotification } from "src/lib/mantine";
import { usePasswordResetRequestMutation } from "src/service/AuthApi";
import { z } from "zod";

const schema = z.object({
  email: z.string().email({ message: "メールアドレスを入力してください。" }),
  role: z.string(),
});

const SignUp: CustomNextPage = () => {
  const [isSend, setIsSend] = useState<boolean>(false);
  const [passwordResetRequest, { isLoading }] =
    usePasswordResetRequestMutation();

  const form = useForm({
    initialValues: {
      email: "",
      role: "STUDENT",
    },
    validate: zodResolver(schema),
  });

  const RequestEmail = form.onSubmit(async (values) => {
    await passwordResetRequest(values)
      .unwrap()
      .then(() => {
        setIsSend(true);
      })
      .catch((e: any) => {
        errorShowNotification(e.data.error.message);
      });
  });
  return (
    <div>
      {isSend ? (
        <div>
          <Text>{`${form.values.email}にメールが送信されました。`}</Text>
          <Box mt={48}>
            <Link
              href="/auth/signin"
              style={{ color: "#00A5B9", textDecoration: "underline" }}
            >
              ログイン画面に戻る
            </Link>
          </Box>
        </div>
      ) : (
        <>
          <Title size={18}>パスワードのリセットを申請</Title>
          <Text mt={16}>パスワードをリセットするメールが送信します。</Text>
          <Text>登録したメールアドレスを入力してください。</Text>
          <Stack mt={24}>
            <LoadingOverlay visible={isLoading} overlayBlur={2} />
            <form onSubmit={RequestEmail}>
              <Box>
                <label htmlFor="email">メールアドレス</label>
                <TextInput
                  id="email"
                  placeholder="example@example.com"
                  withAsterisk
                  {...form.getInputProps("email")}
                />
              </Box>
              <Center mt={24}>
                <Button
                  type="submit"
                  sx={{
                    borderRadius: "100px",
                    height: "auto",
                    maxWidth: "256px",
                    padding: "14.5px 0",
                    width: "100%",
                  }}
                >
                  送信
                </Button>
              </Center>
            </form>
          </Stack>
          <Box mt={48}>
            <Link
              href="/auth/signin"
              style={{ color: "#00A5B9", textDecoration: "underline" }}
            >
              ログイン画面に戻る
            </Link>
          </Box>
        </>
      )}
    </div>
  );
};

SignUp.getLayout = AuthLayout;

export default SignUp;
